
import * as Constants from './Constants';

const initialState = {
  title: 'Tagging',
  readDlPlans: false,
};

function Tagging(state = initialState, action) {
  switch (action.type) {
    case Constants.TAGGING_SUCCESS:
      return { ...state, channelSession: action.response };
      case Constants.READDL_SUCCESS:
      return { ...state, readDlPlans: action.response };
    default:
      return state;
  }
}

export default Tagging;
